import { round } from "@ugg/shared/utils/math";
import { RoleC, RoleN } from "@ugg/shared/utils/role-helpers";
import { RegionC, RegionN } from "@ugg/shared/utils/region-helpers";
import { RankC, RankN } from "@ugg/shared/utils/rank-helpers";
import { getKey, getData } from "./common";
import { Items, ItemId, ItemData, StartingItemsData } from "@ugg/shared/interfaces/champions/items.interface";

export function getItems(
  data: ReturnType<typeof cleanItems>,
  params: {
    queueType: string;
    region: string;
    rank?: string;
    role?: string;
  },
) {
  return getData(data, params);
}

export interface ItemsInfo {
  starting_items: Array<{
    ids: ItemId[];
    wins: StartingItemsData[1];
    matches: StartingItemsData[2];
    win_rate: number;
    pick_rate: number;
  }>;
  items_1: Array<{
    ids: ItemId[];
    wins: ItemData[1];
    matches: ItemData[2];
    win_rate: number;
    pick_rate: number;
  }>;
  boots: Array<{
    ids: ItemId[];
    wins: ItemData[1];
    matches: ItemData[2];
    win_rate: number;
    pick_rate: number;
  }>;
  items_2: Array<{
    ids: ItemId[];
    wins: ItemData[1];
    matches: ItemData[2];
    win_rate: number;
    pick_rate: number;
  }>;
  items_3: Array<{
    ids: ItemId[];
    wins: ItemData[1];
    matches: ItemData[2];
    win_rate: number;
    pick_rate: number;
  }>;
  items_4: Array<{
    ids: ItemId[];
    wins: ItemData[1];
    matches: ItemData[2];
    win_rate: number;
    pick_rate: number;
  }>;
  items_5: Array<{
    ids: ItemId[];
    wins: ItemData[1];
    matches: ItemData[2];
    win_rate: number;
    pick_rate: number;
  }>;
}

export function cleanItems(data: Items) {
  const cleanData: Record<string, ItemsInfo> = {};

  const regionKeys: RegionN[] = Object.keys(data || {}).map(Number);
  for (const regionId of regionKeys) {
    const regionData = data[regionId];
    const rankKeys: RankN[] = Object.keys(regionData || {}).map(Number);

    for (const rankId of rankKeys) {
      const rankData = regionData[rankId];
      const roleKeys: RoleN[] = Object.keys(rankData || {}).map(Number);

      for (const roleId of roleKeys) {
        const roleData = rankData[roleId];

        const [starting_items, items_1, boots, items_2, items_3, items_4, items_5] = roleData.map((set) => {
          let totalMatches = 0;
          set.forEach((item) => (totalMatches += item[2]));

          return set.map((item) => {
            const wins = item[1];
            const matches = item[2];

            return {
              ids: Array.isArray(item[0]) ? item[0] : [item[0]],
              wins: item[1],
              matches: item[2],
              win_rate: round((wins / matches) * 100, 2),
              pick_rate: round((matches / totalMatches) * 100, 2),
            };
          });
        });

        const items = {
          starting_items,
          items_1,
          boots,
          items_2,
          items_3,
          items_4,
          items_5,
        };

        const key = getKey(RegionC.convertToString(regionId), RankC.convertToString(rankId), RoleC.convertToString(roleId));
        cleanData[key] = items;
      }
    }
  }

  return cleanData;
}
